import { FilterBuilder, type FilterBuilderProps } from "@tfg/ui"

import {
  useFiltersOperatorsLabelsTranslations,
  useFiltersOperatorsValuesResolver,
} from "~/hooks/useFiltersOperatorsTranslations"

export type FilterBuilderWrapperProps<T> = Omit<
  FilterBuilderProps<T>,
  "labelTranslationResolver" | "valueResolver"
>

export function FilterBuilderWrapper<
  T extends Partial<Record<string, unknown>>,
>(props: FilterBuilderWrapperProps<T>) {
  const labelTranslationResolver = useFiltersOperatorsLabelsTranslations()
  const valueResolver = useFiltersOperatorsValuesResolver()

  return (
    <FilterBuilder
      {...props}
      labelTranslationResolver={labelTranslationResolver}
      valueResolver={valueResolver}
    />
  )
}
